import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding-right: 72px;\n  width: calc(100% - 340px);\n  @media (max-width: 1200px) {\n    width: 100%;\n    padding-right: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  @media (max-width: 1200px) {\n    padding: 0 12px;\n  }\n  @media (max-width: 768px) {\n    position: relative;\n    padding: 8px 16px;\n  }\n\n  .detail-content {\n    padding-top: 48px;\n    display: flex;\n    flex-direction: column;\n    @media (max-width: 768px) {\n      padding-top: 32px;\n    }\n  }\n\n  .studio-promotion-image {\n    margin-top: 44px;\n\n    &.m {\n      display: none;\n    }\n\n    @media (max-width: 768px) {\n      &.w {\n        display: none;\n      }\n\n      &.m {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  z-index: 2;\n  display: flex;\n  position: sticky;\n  top: ",
        "px;\n  background-color: ",
        ";\n  align-items: center;\n  justify-content: space-around;\n  cursor: pointer;\n  font-weight: 600;\n  color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  transition: top 0.2s ease-in-out;\n\n  :before,\n  :after {\n    content: '';\n    display: block;\n    width: calc(100%);\n    position: absolute;\n    bottom: -1px;\n    border-bottom: 1px solid ",
        ";\n    @media (max-width: 1200px) {\n      width: 30px;\n    }\n  }\n\n  :before {\n    right: calc(100% + 60px);\n    left: 100%;\n  }\n\n  :after {\n    right: 100%;\n  }\n\n  body:has(.headroom--unpinned) & {\n    top: 0;\n  }\n\n  li {\n    flex: 1;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n\n    a {\n      padding: 16px 10px;\n      width: 100%;\n      flex: 1;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      line-height: 1.5;\n      color: ",
        ";\n\n      &.active {\n        padding: 16px 10px 14px;\n        border-bottom: 2px solid ",
        ";\n        color: ",
        ";\n      }\n    }\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    font-size: 14px;\n    margin: 0 -16px;\n    top: ",
        "px;\n    li a {\n      padding: 12px 5px;\n      &.active {\n        padding: 12px 5px 10px;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  padding: 32px;\n  background-color: ",
        ";\n  border-radius: 6px;\n\n  p {\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n    margin: 0 0 8px;\n    line-height: 22px;\n  }\n\n  h5 {\n    height: 32px;\n    display: flex;\n    font-size: 24px;\n    font-weight: 600;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .img-wrapper {\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      margin-right: 8px;\n      display: flex;\n      align-items: center;\n\n      img {\n        border-radius: 50%;\n        height: fit-content;\n      }\n    }\n\n    a {\n      color: ",
        ";\n      font-size: 14px;\n      margin-left: 12px;\n      display: flex;\n      align-items: center;\n\n      i {\n        vertical-align: middle;\n      }\n    }\n  }\n\n  > div {\n    font-size: 16px;\n    color: ",
        ";\n    line-height: 27px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 20px;\n    p {\n      font-size: 12px;\n    }\n\n    h5 {\n      font-size: 20px;\n      margin-bottom: 16px;\n    }\n\n    > div {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  &:nth-of-type(1) {\n    padding-top: 0;\n  }\n\n  border-radius: 6px;\n  padding-top: 72px;\n\n  > h3 {\n    font-size: 20px;\n    margin-bottom: 16px;\n    font-weight: 700;\n  }\n\n  .wrapper {\n    border-radius: 6px;\n    background-color: ",
        ";\n    padding: 20px;\n    color: ",
        ";\n    white-space: pre-wrap;\n    word-break: keep-all;\n    span {\n      line-height: 1.5;\n    }\n\n    > :first-child.title {\n      margin-bottom: 8px;\n    }\n    .title {\n      font-weight: 700;\n    }\n  }\n\n  @media (max-width: 768px) {\n    > h3 {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  div {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  img {\n    border-radius: 6px;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  .description {\n    margin-bottom: 16px;\n    line-height: 1.5;\n  }\n  ul {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 16px;\n\n    li {\n      width: calc(50% - 20px);\n      display: flex;\n\n      span {\n        display: inline-block;\n        line-height: 1.5;\n      }\n\n      span.title {\n        width: 100px;\n      }\n\n      span.content {\n        width: calc(100% - 100px);\n        color: ",
        ";\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    ul {\n      flex-direction: column;\n\n      li {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  .info-cell {\n    display: flex;\n    gap: 16px;\n\n    margin-top: 32px;\n\n    @media screen and (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .title {\n      min-width: 100px;\n      font-weight: 600;\n    }\n\n    .content {\n      color: ",
        ";\n      flex-grow: 1;\n      line-height: 1.5;\n      white-space: break-spaces;\n      > p {\n        line-height: 1.5;\n        color: ",
        ";\n      }\n\n      text-align: justify;\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  ",
        "\n  h3 {\n    ",
        "\n  }\n  .content {\n    line-height: 1.5;\n    color: ",
        ";\n  }\n\n  .wrapper:not(:last-of-type) {\n    margin-bottom: 24px;\n  }\n\n  ul > li {\n    color: ",
        ";\n    list-style-type: disc;\n    margin-inline-start: 24px;\n  }\n\n  ol {\n    padding: 0;\n    margin-bottom: 0;\n  }\n  ol > li {\n    color: ",
        ";\n    list-style-type: decimal;\n    margin-inline-start: 24px;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  position: sticky;\n  margin-top: 56px;\n  top: 131px;\n\n  padding-top: 40px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _tagged_template_literal([
        "\n  span:first-child {\n    margin-right: 16px;\n  }\n\n  > div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  div {\n    color: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    span {\n      font-size: 14px;\n    }\n\n    span:first-child {\n      margin-right: 12px;\n    }\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
import { GNBHeight, GNBHeightMobile } from "@/containers/Header/GNB.style";
import { Element } from "react-scroll";
import styled from "styled-components";
const ScrollSection = styled.div.withConfig({
    componentId: "sc-696eb70e-0"
})(_templateObject());
const ProductDetailContentWrapper = styled.div.withConfig({
    componentId: "sc-696eb70e-1"
})(_templateObject1());
const StyledAnchor = styled.ul.withConfig({
    componentId: "sc-696eb70e-2"
})(_templateObject2(), GNBHeight, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_400, (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_400, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500, GNBHeightMobile);
const AuthorTab = styled(Element).withConfig({
    componentId: "sc-696eb70e-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_gray_500);
const ContentWrapper = styled(Element).withConfig({
    componentId: "sc-696eb70e-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_600);
const PreviewTab = styled(ContentWrapper).withConfig({
    componentId: "sc-696eb70e-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_100);
const DetailTab = styled(ContentWrapper).withConfig({
    componentId: "sc-696eb70e-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_600);
const BookInfoTab = styled(ContentWrapper).withConfig({
    componentId: "sc-696eb70e-7"
})(_templateObject7(), (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600);
const RefundTab = styled(ContentWrapper).withConfig({
    componentId: "sc-696eb70e-8"
})(_templateObject8(), (props)=>props.producttype === "handout" && "padding-top: 0;", (props)=>props.producttype === "handout" && "font-size:16px ;", (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600);
const PriceTab = styled.div.withConfig({
    componentId: "sc-696eb70e-9"
})(_templateObject9());
const ContentsTab = styled(ContentWrapper).withConfig({
    componentId: "sc-696eb70e-10"
})(_templateObject10(), (props)=>props.theme.new.colors.sol_gray_600);
export { AuthorTab, BookInfoTab, ContentsTab, ContentWrapper, DetailTab, PreviewTab, PriceTab, ProductDetailContentWrapper, RefundTab, ScrollSection, StyledAnchor,  };
